import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { authService } from "@/services/api";
import { AuthShell, Field } from "./AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Loader2, UserPlus } from "lucide-react";

export default function InviteAccept() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [name, setName] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return;
    setLoading(true);
    try {
      const user = await authService.acceptInvite(token, pw, name);
      setUser(user);
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.error || "Could not accept this invite");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell testId="invite-page">
        <h1 className="font-display text-2xl font-semibold tracking-tight">Invalid invite link</h1>
        <p className="mt-1.5 text-sm text-muted-foreground">This link is missing its invite token. Ask whoever invited you for a fresh link.</p>
      </AuthShell>
    );
  }

  return (
    <AuthShell testId="invite-page">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-border/60 bg-secondary/40 text-primary">
        <UserPlus className="h-6 w-6" />
      </div>
      <h1 className="font-display text-2xl font-semibold tracking-tight">Join your organization</h1>
      <p className="mt-1.5 text-sm text-muted-foreground">Set your name and a password to activate your account.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <Field label="Full name">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" required className="h-11" data-testid="invite-name" />
        </Field>
        <Field label="Create password">
          <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="••••••••" required minLength={8} className="h-11" data-testid="invite-pw" />
        </Field>
        <Button type="submit" className="h-11 w-full" disabled={loading} data-testid="invite-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accept invitation"}
        </Button>
      </form>
    </AuthShell>
  );
}
